import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PhotoPage from "./pages/PhotoPage";

function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* The coupon QR points at vejthani33years.com/<code>, so the code arrives
            as a path. "/" is kept for anyone who opens the site directly, and the
            old ?userid= links still work (PhotoPage reads both). */}
        <Route path="/" element={<PhotoPage />} />
        <Route path="/:code" element={<PhotoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
